import React from "react";

import { GridLegacy } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import Overzicht from "../../../components/ProductOpties/Overzicht";
import { useController } from "react-hook-form";
import FormJson from "../../../components/Forms/FormJson";

function Opties() {
  const {
    field: { value: optiesValue, onChange: optiesOnChange },
  } = useController({ name: "opties" });

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <Overzicht
            onChange={(opties) => {
              optiesOnChange(JSON.stringify(opties));
            }}
            opties={optiesValue}
          />

          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <FormJson name={"opties"} tDefault={"Opties JSON"} tKey={"producten.opties.json"} />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Opties;
